import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import dayjs from 'dayjs';
;
const TermsAndConditions = ({ traderInfo, }) => {
    const styles = StyleSheet.create({
        container: {
            padding: 10,
        },
        title: {
            fontSize: 16,
            color: '#137AB1',
            fontFamily: 'Roboto',
            fontStyle: 'bold',
            fontWeight: 700,
            textAlign: 'left',
            marginTop: 0,
        },
        terms: {
            fontSize: 8,
        },
        entryContainer: {
            marginTop: 20,
            marginBottom: 10,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-evenly',
        },
        entryCol: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'space-evenly',
            marginBottom: 8,
        },
        subtitle: {
            fontSize: 9,
            fontFamily: 'Roboto',
            marginTop: 4,
        },
        text: {
            fontSize: 12,
            fontFamily: 'Roboto',
            textAlign: 'left',
        },
    });
    const date = dayjs().format('MM/DD/YYYY');
    return (_jsxs(View, { style: styles.container, children: [_jsx(Text, { style: styles.title, children: "Terms and Conditions" }), _jsx(Text, { style: styles.terms, children: "The undersigned (Applicant) certifies that the information contained herein is true and correct, and further authorizes TopRx, LLC (Seller), to make any inquiries necessary for verification of the information provided. The Applicant hereby indemnifies the Seller, and its agents, from any liability resulting from their credit inquiry. The Applicant further agrees that if credit is extended, all credit and sales made shall be subject to the following terms and conditions: (1) Applicant shall pay the full amount of the invoice(s) when due, which is defined to be thirty (30) days from the invoice date unless otherwise specified on the invoice or agreed to in writing by the Seller; (2) If payment in full is not received by the due date, Applicant shall owe, in addition to the invoice amount, a late fee of 1.5% permonth (18% annum), or the maximum allowed by law, on all unpaid balances, plus costs of collection, including, but not limited to,attorney\u2019s fees, court costs, and collection fees that the Seller may incur in recovering the amount that is owed; (3) Applicant agreesthat venue and jurisdiction for any such court action shall properly be at Shelby County, TN, the principal place of business of Seller." }), _jsx(Text, { style: { ...styles.terms, marginTop: 5, }, children: "I further certify that I am knowledgeable of the financial condition of Applicant and that I am empowered and authorized to enter into the aforesaid Agreement on Applicant\u2019s behalf. I further certify on Applicant\u2019s behalf that Applicant is solvent as defined by Article 1 of the Uniform Commercial Code, and that Applicant will immediately notify the Seller if it becomes insolvent. I understand that TopRx, LLC reports to Business Crediting Reporting Agencies." }), _jsxs(View, { style: styles.entryContainer, children: [_jsxs(View, { style: styles.entryCol, children: [_jsx(Text, { style: styles.text, children: `${traderInfo.owner.firstName} ${traderInfo.owner.lastName}` }), _jsx(Text, { style: styles.subtitle, children: "Authorized Signer's Name" }), _jsx(View, { style: { marginTop: '30px', } }), _jsx(Text, { style: styles.text, children: "_____________________________" }), _jsx(Text, { style: styles.subtitle, children: "Authorized Signature" })] }), _jsxs(View, { style: styles.entryCol, children: [_jsx(Text, { style: styles.text, children: "Owner" }), _jsx(Text, { style: styles.subtitle, children: "Authorized Signer's Title" }), _jsx(View, { style: { marginTop: '30px', } }), _jsx(Text, { style: styles.text, children: date }), _jsx(Text, { style: styles.subtitle, children: "Date" })] })] })] }));
};
export default TermsAndConditions;
